<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
       
        <b-button block v-b-toggle.term-section-14
          class="text-left fw-500 d-flex align-items-center justify-content-between">
              <div>
                  <span class="box-numbering">14</span>
                  <span>Contact Information</span>    
              </div>
              <span 
                  class="toggle-icon" 
                  :class="{ active: isOpen }"
              >
                  <span class="plus">+</span>
                  <span class="cross">×</span>
              </span> 
        </b-button>

      </b-card-header>
      <b-collapse
        id="term-section-14"
        visible
        accordion="my-accordion"
        role="tabpanel"
        @show="isOpen = true"
        @hide="isOpen = false"
      >
        <b-card-body>
          <p class="text-justify">
            Contact Information If you have any questions or concerns about these Terms or your {{ companyName }} card, please contact us at:
            <ol>
              <li>{{ companyName }}</li>
              <li>Room B11, First Floor, Providence Complex,</li>
              <li>Providence, Mahe, Seychelles</li>
              <li>support@oripay.us</li>
            </ol>
          </p>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "term-5",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isOpen: true
    };
  },
  props:['companyName']
};
</script>
